import z from 'zod';
import { entity, shareConfig, contactListRef, customerRef, schedule, timeGranularity, locale, AlarmSeverity, AlarmType, objectPassthrough, defaultShareConfig, assetRef, assetGroupRef, string, datetime, procedureString, longString, } from '../common';
export var ReportTriggerChannelType;
(function (ReportTriggerChannelType) {
    ReportTriggerChannelType["Email"] = "email";
    ReportTriggerChannelType["Sms"] = "sms";
    ReportTriggerChannelType["Alarm"] = "alarm";
})(ReportTriggerChannelType || (ReportTriggerChannelType = {}));
export const reportTriggerChannelGetter = z.object({
    path: string,
});
export const reportTriggerEmailChannelConfig = z.object({
    subjectOverride: string.optional(),
    headerOverride: longString.optional(),
});
export const reportTriggerEmailChannel = z.object({
    type: z.literal(ReportTriggerChannelType.Email),
    address: string.array().optional(),
    contactLists: contactListRef.array().optional(),
    getters: reportTriggerChannelGetter.array().optional(),
    assets: assetRef.array().optional(),
    assetGroups: assetGroupRef.array().optional(),
    config: reportTriggerEmailChannelConfig.optional(),
});
export const reportTriggerSmsChannel = z.object({
    type: z.literal(ReportTriggerChannelType.Sms),
    numbers: string.array(),
    contactLists: z.array(contactListRef),
});
export const reportTriggerAlarmChannelConfig = z.object({
    severity: z.nativeEnum(AlarmSeverity),
    type: z.nativeEnum(AlarmType),
    procedure: procedureString,
    name: string,
});
export const reportTriggerAlarmChannel = z.object({
    type: z.literal(ReportTriggerChannelType.Alarm),
    config: reportTriggerAlarmChannelConfig,
});
export const anyReportTriggerChannel = z.discriminatedUnion('type', [
    reportTriggerEmailChannel,
    reportTriggerSmsChannel,
    reportTriggerAlarmChannel,
]);
export const reportScheduleTrigger = z.object({
    interval: timeGranularity,
    cooldown: timeGranularity.optional(),
    nextAt: datetime.nullable(),
    lastAt: datetime.nullable(),
    lastAttemptedAt: datetime.nullable(),
});
export const reportEventTrigger = z.object({
    events: string.array(),
    executionDelay: timeGranularity.optional(),
    schedule: schedule.optional(),
});
export const reportTrigger = z.object({
    ...entity.shape,
    customer: customerRef.nullable(),
    share: shareConfig.default(defaultShareConfig),
    config: objectPassthrough({
        type: string,
    }),
    channels: anyReportTriggerChannel.array(),
    scheduleTrigger: reportScheduleTrigger.nullable().default(null),
    eventTrigger: reportEventTrigger.nullable().default(null),
    enabled: z.boolean(),
    locale: locale.optional(),
    timezone: string.optional(),
});
